<template>
  <HomePokemon/>
</template>


<script>
import HomePokemon from '@/views/HomePokemon.vue'
export default {
    name: 'App',
    components: { HomePokemon }
}
</script>